import React, { Component } from 'react';
import BaseLayout from '../../templates/base';
import SurveysEditForm from './../../elements/surveys/form';
import Loading from "../../elements/loading";
import SurveysAdd from './../../elements/surveys/widget/surveys_add';

class SurveyCreate extends Component {
	render(){
		const { surveys, status } = this.props;
		return(
			surveys.isFetching || surveys.types.isFetching || status.isFetching ? <Loading/>:<SurveysEditForm {...this.props}/>
		);
	}

	componentWillMount(){
		this.props.surveysClear();
		this.props.surveysFetchTypes();
		this.props.fetchStatus(1);
	}
}

//export default BaseLayout(SurveyCreate, {title: `Crear Encuesta`, subnav: {icon: 'fa-clipboard', name: 'Encuestas', actions: {url: '/encuestas/crear', name: 'Agregar encuesta'}}});
export default BaseLayout(SurveyCreate, {
	title: `Crear Encuesta`,
	subnav: {
		icon: 'fa-clipboard',
		name: 'Administracion',
		actions: [
			{
				type: 'element',
				url: null,
				name: 'Agregar',
				element: <SurveysAdd />
			}
		]
	}
});


// WEBPACK FOOTER //
// ./src/layouts/surveys/create.jsx